import type { UserInfo } from '@/stores/user/types';
import { FBQ, GTM } from '@wegic/analytics';
import { getCommonTrackingData, withPrefixToKeys } from '@wegic/common';
import { getBrowser } from '@wegic/utils';
import { collect, flushCollectQueue, setCollectUserId } from '@/modules/Collect/helper';
import { useI18nStore } from '@/stores/i18n';

type AuthType = 'email' | 'google';

export type LoginType = AuthType | 'onetap' | 'password_reset';
export type SignupType = AuthType | 'onetap';

function getSignupTrackingData() {
  try {
    return withPrefixToKeys(getCommonTrackingData(), 'signup_');
  } catch {
    return {};
  }
}

export function trackLoginClick(loginType: AuthType) {
  collect('login_click', { login_type: loginType });
}

/**
 * 用户登录埋点
 */
export function trackLogin(userId: string, loginType: LoginType) {
  setCollectUserId(userId);
  collect('user_login', { login_type: loginType });
  flushCollectQueue();
}

/**
 * 用户注册埋点
 */
export function trackSignup(userInfo: UserInfo, signupType: SignupType) {
  const currentLanguage = useI18nStore.getState().currentLanguage;

  const browser = getBrowser();
  const signupDevice = browser.getPlatformType() || 'desktop';

  const pageViewType = typeof window !== 'undefined' ? sessionStorage.getItem('page_view_type') : null;
  const urlParams = new URLSearchParams(window.location.search);
  const fromHome = urlParams.get('fromHome');

  // 只有当 type 是 seo 或 sem 时才上报 fromHome
  const shouldReportFromHome = fromHome && (pageViewType === 'seo' || pageViewType === 'sem');

  // 获取模板注册来源 URL
  const signupTemplate = typeof window !== 'undefined' ? sessionStorage.getItem('signup_template') : null;
  if (signupTemplate) {
    sessionStorage.removeItem('signup_template');
  }

  setCollectUserId(userInfo.userId);
  collect('user_signup', {
    signup_type: signupType,
    signup_language: currentLanguage,
    signup_device: signupDevice,
    signup_time: userInfo.createDate,
    ...(shouldReportFromHome && { signup_subsource: fromHome }),
    ...(signupTemplate && { signup_template: signupTemplate }),
    ...getSignupTrackingData(),
  });
  flushCollectQueue();

  GTM.signUpEvent();
  FBQ.completeRegistration();
}
